export const CNC_DAMAGE_REQUEST = "CNC_DAMAGE_REQUEST";
export const CNC_DAMAGE_SUCCESS = "CNC_DAMAGE_SUCCESS";
export const CNC_DAMAGE_FAILED = "CNC_DAMAGE_FAILED";